import { ExpressionValue } from "../../ExpressionValue";
import { BaseLogicExpression } from "../Logic/BaseLogic";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringStartWithExpression extends BaseLogicExpression {
    readonly __type: string = "String Start With";
    readonly __ruleName: string = "Starts With";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new StringDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).startsWith(this.value2.evaluate(data, testContext));
    }
}
